import * as React from "react";
import type { SVGProps } from "react";
const SvgTerminateIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.287 5.355a1 1 0 0 1-.12 1.41 7.5 7.5 0 1 0 9.665 0 1 1 0 1 1 1.29-1.53 9.5 9.5 0 1 1-12.245 0 1 1 0 0 1 1.41.12Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 2a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTerminateIcon;
